const doc = [({"en":({"adminConstantHotelQuestionAnswerType":({"radio":"Options (radio)", "selectTag":"Options (pull-down)", "text":"One line text", "textarea":"Multiple line text"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;